"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
var _intlTs = require("@gogame/intl-ts");
var _useForkRef = _interopRequireDefault(require("@mui/material/utils/useForkRef"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["value", "inputRef", "onChange", "name", "thousandSeparator"],
  _excluded2 = ["type", "decimalScale", "currency", "thousandSeparator"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var CustomNumberFormat = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var value = _ref.value,
    inputRef = _ref.inputRef,
    onChange = _ref.onChange,
    name = _ref.name,
    _ref$thousandSeparato = _ref.thousandSeparator,
    thousandSeparator = _ref$thousandSeparato === void 0 ? true : _ref$thousandSeparato,
    props = _objectWithoutProperties(_ref, _excluded);
  var innerInputRef = (0, _react.useRef)(null);
  var numberFormatterRef = (0, _react.useRef)(null);
  var valueRef = (0, _react.useRef)(null);
  var onChangeRef = (0, _react.useRef)(null);
  var internalValueRef = (0, _react.useRef)(value);
  var handleInputRef = (0, _useForkRef["default"])(inputRef, innerInputRef);
  var valuesRef = (0, _react.useRef)({
    floatValue: value
  });
  valueRef.current = value;
  onChangeRef.current = onChange;
  var resetRange = (0, _react.useCallback)(function () {
    setTimeout(function () {
      var _innerInputRef$curren;
      (_innerInputRef$curren = innerInputRef.current) === null || _innerInputRef$curren === void 0 || _innerInputRef$curren.setSelectionRange(innerInputRef.current.value.length, innerInputRef.current.value.length);
    }, 100);
  });
  var handleNumberChange = (0, _react.useCallback)(function (values) {
    valuesRef.current = values;
  }, []);
  var handleChange = (0, _react.useCallback)(function (_e) {
    var floatValue = valuesRef.current.floatValue;
    if (valueRef.current !== floatValue) {
      var event = {
        persist: function persist() {},
        target: {
          name: name,
          value: floatValue
        }
      };
      internalValueRef.current = floatValue;
      onChangeRef.current(event);
    }
  }, [onChange]);
  (0, _react.useEffect)(function () {
    if (internalValueRef.current !== value && !isNaN(value)) {
      resetRange();
    }
  }, [value, onChange]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactNumberFormat["default"], _objectSpread({
    ref: numberFormatterRef,
    thousandSeparator: thousandSeparator,
    getInputRef: ref,
    inputRef: handleInputRef,
    value: value,
    onValueChange: handleNumberChange,
    onChange: handleChange,
    name: name
  }, props));
});
var withInputFormatter = function withInputFormatter() {
  return function (InputComponent) {
    return /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
      var type = _ref2.type,
        decimalScale = _ref2.decimalScale,
        currencyProp = _ref2.currency,
        thousandSeparator = _ref2.thousandSeparator,
        props = _objectWithoutProperties(_ref2, _excluded2);
      var currency = currencyProp || 'USD';
      var getCurrencySymbol = (0, _intlTs.useCurrencySymbol)();
      var prefix = (0, _react.useMemo)(function () {
        return getCurrencySymbol(currency);
      }, [currency]);
      switch (type) {
        case 'currency':
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomNumberFormat, _objectSpread({
            decimalScale: decimalScale,
            currency: currency,
            prefix: prefix,
            getInputRef: ref,
            customInput: InputComponent,
            thousandSeparator: !!thousandSeparator
          }, props));
        case 'number':
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomNumberFormat, _objectSpread({
            decimalScale: decimalScale,
            getInputRef: ref,
            customInput: InputComponent,
            thousandSeparator: !!thousandSeparator
          }, props));
        case 'percent':
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomNumberFormat, _objectSpread({
            suffix: '%',
            decimalScale: decimalScale,
            getInputRef: ref,
            customInput: InputComponent
          }, props));
        case 'days':
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomNumberFormat, _objectSpread({
            suffix: ' days',
            decimalScale: decimalScale,
            getInputRef: ref,
            customInput: InputComponent
          }, props));
        case 'text':
        case 'password':
        default:
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(InputComponent, _objectSpread(_objectSpread({}, props), {}, {
            type: type,
            ref: ref
          }));
      }
    });
  };
};
var _default = exports["default"] = withInputFormatter;